import style_inject_es_default from "../../../../../../../node_modules/.pnpm/style-inject@0.3.0/node_modules/style-inject/dist/style-inject.es.js";

//#region src/components/inputs/form-field-error/form-field-error.module.css
var css_248z = ".form-field-error-module_root__XcnH-,\n.form-field-error-module_centered__JK0Iv {\n    display: inline-flex;\n    align-items: start;\n    gap: var(--mantine-spacing-xxs);\n    font-size: var(--mantine-font-size-sm);\n    margin-top: 2px;\n    color: var(--mantine-color-error-7);\n}\n\n.form-field-error-module_centered__JK0Iv {\n    justify-content: center;\n}\n";
var form_field_error_module_default = {
	"root": "form-field-error-module_root__XcnH-",
	"centered": "form-field-error-module_centered__JK0Iv"
};
style_inject_es_default(css_248z);

//#endregion
export { form_field_error_module_default as default };